export const normalizeDigits = (value = "") => {
  return value
    .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
    .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));
};

export const normalizePhone = (value = "") => {
  return normalizeDigits(value).replace(/\D/g, "").trim();
};
